import { render, staticRenderFns } from "./adminTransaccionesPortalComercial.vue?vue&type=template&id=4eea8b38"
import script from "./adminTransaccionesPortalComercial.vue?vue&type=script&lang=js"
export * from "./adminTransaccionesPortalComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports